<template>
    <header class="row fixed-top">
        <div class="container">
            <div class="row">
                <div class="col-6 col-lg-2">
                    <router-link to="/">
                        <img alt="Phoeniz website" src="/assets/images/logo.png">
                    </router-link>
                </div>
                <div class="col-6 col-lg-10 d-none d-lg-block">
                    <nav class="nav top-nav">
                        <router-link class="nav-link d-lg-inline-block" :to="{name: 'HomePageComponent'}">Trang chủ</router-link>
                        <router-link class="nav-link d-lg-inline-block" to="/#sectionAboutUs">Về chúng tôi</router-link>
                        <router-link class="nav-link d-lg-inline-block" to="/#sectionProducts">Sản phẩm</router-link>
                        <router-link class="nav-link d-lg-inline-block" :to="{name: 'NewsPageComponent'}">Tin tức</router-link>
                        <router-link class="nav-link d-lg-inline-block" :to="{name: 'RecruitmentPageComponent'}">Tuyển dụng</router-link>
                        <router-link class="nav-link d-lg-inline-block" :to="{name: 'ContactPageComponent'}">Liên hệ</router-link>
                    </nav>
                </div>
                <div class="col-6 col-lg-10 d-block d-lg-none text-right">
                    <div class="dropdown">
                        <img aria-expanded="false" aria-haspopup="true"
                             class="mt-3 w-25 dropdown-toggle" data-toggle="dropdown" src="/assets/images/mobile_menu.png"/>
                        <div aria-labelledby="dropdownMenu2" class="dropdown-menu">
                            <router-link class="dropdown-item" :to="{name: 'HomePageComponent'}">Trang chủ</router-link>
                            <router-link class="dropdown-item" to="/#sectionAboutUs">Về chúng tôi</router-link>
                            <router-link class="dropdown-item" to="/#sectionProducts">Sản phẩm</router-link>
                            <router-link class="dropdown-item" :to="{name: 'NewsPageComponent'}">Tin tức</router-link>
                            <router-link class="dropdown-item" :to="{name: 'RecruitmentPageComponent'}">Tuyển dụng</router-link>
                            <router-link class="dropdown-item" :to="{name: 'ContactPageComponent'}">Liên hệ</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
    export default {
        name: "HeaderComponent"
    }
</script>

<style scoped>

</style>
